export default __webpack_public_path__ + "static/media/INXP.3de27775.png";